/**
 * @package {COMPONENT NAME}
 *
 * Entry point for Javascript package
 */
// @ts-ignore
import Cookies from 'js-cookie';
// Get cookie container and button
var cookieContainer = document.getElementById('soul_cookie_notice');
var cookieButton = document.getElementById('soul_cookie_notice_btn');
// Set cookie name
var cookieName = "cookie_consent";
// When user clicks the button
// Set consent for a year and remove the container
function handleCookie() {
    Cookies.set(cookieName, true, {
        expires: 365
    });
    cookieContainer.remove();
}
// Add event listener to cookie button
cookieButton.addEventListener('click', handleCookie);
